import {Routes} from '@angular/router';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'page-not-found',
        component: PageNotFoundComponent
      },
      // {
      //   path: 'server',
      //   component: ServerErrorComponent
      // }
    ]
  }];
